import React from 'react'
import { TabProps } from '../types'
import HomeTransactions from '../../../../transactions'

const MemberTransaction: React.FC<TabProps> = () => <HomeTransactions />

export default MemberTransaction
